var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgTickIconGreen(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 14,
    viewBox: "0 0 14 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13.25 7.74998C12.75 10.25 10.865 12.604 8.21998 13.13C6.92997 13.3869 5.59179 13.2303 4.39598 12.6824C3.20018 12.1345 2.2077 11.2233 1.55988 10.0786C0.912049 8.93383 0.641899 7.61387 0.78789 6.30666C0.933882 4.99944 1.48857 3.77161 2.37298 2.79798C4.18698 0.799985 7.24998 0.249985 9.74998 1.24998",
    stroke: "#7fe77f",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M4.75 6.75L7.25 9.25L13.25 2.75",
    stroke: "#7fe77f",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTickIconGreen);
export default __webpack_public_path__ + "static/media/tick-icon-green.b0f8f9758433dd1a0f23d0c06a276f0a.svg";
export { ForwardRef as ReactComponent };